module.exports = __webpack_public_path__ + "assets/img/message_phone.f55923c6.svg";